import React, { useState, useEffect } from 'react';
import { userAPI } from '../api';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

// Recursive component to display tree
const TreeNode = ({ node }) => {
  if (!node) return null;

  return (
    <li className="mb-2">
      <div className="flex items-center gap-2">
        <span className="font-semibold text-secondary">{node.name}</span>
        <span className="text-xs text-gray-500">({node.rank})</span>
      </div>
      {node.children && node.children.length > 0 && (
        <ul className="pl-6 mt-1 border-l border-gray-300">
          {node.children.map((child) => (
            <TreeNode key={child._id} node={child} />
          ))}
        </ul>
      )}
    </li>
  );
};

const Network = () => {
  const { user } = useAuth();
  const [network, setNetwork] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchNetwork();
  }, [user?._id]);

  const fetchNetwork = async () => {
    try {
      setLoading(true);
      const res = await userAPI.getNetwork(user._id);
      setNetwork(res.data);
      setError('');
    } catch (err) {
      setError('Failed to load network');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-screen"><LoadingSpinner /></div>;
  if (error) return <div className="flex items-center justify-center min-h-screen text-red-600">{error}</div>;

  return (
    <div className="max-w-7xl mx-auto px-5 py-10">
      <div className="mb-10">
        <h1 className="text-4xl font-bold text-secondary mb-2">My Network</h1>
        <p className="text-gray-500">Visual representation of your referral tree</p>
      </div>

      {!network || (!network.sponsor && !network.directSponsees.length) ? (
        <p className="text-gray-600">No network data available.</p>
      ) : (
        <ul>
          {network.sponsor && (
            <li className="mb-2">
              <div className="text-gray-600 text-sm">Sponsor</div>
              <TreeNode node={network.sponsor} />
            </li>
          )}
          {network.directSponsees && network.directSponsees.length > 0 && (
            <li className="mb-2">
              <div className="text-gray-600 text-sm">Direct Sponsees</div>
              <ul className="pl-4 mt-1">
                {network.directSponsees.map((node) => (
                  <TreeNode key={node._id} node={node} />
                ))}
              </ul>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Network;